import React, { Component } from "react";
import { compressImage } from "../../utils/imageUtils";
import { uploadImageToStorage } from "../../utils/uploadImageToStorage";

class ImageReplaceModal extends Component {
  handleReplace = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      const compressed = await compressImage(file);
      const newUrl = await uploadImageToStorage(compressed, "blogPhotos");
      this.props.onPhotoReplace(this.props.index, newUrl);
      this.props.onClose();
    } catch (err) {
      console.error("Photo replacement failed", err);
    }
  };

  render() {
    const { imageUrl, onClose } = this.props;

    return (
      <div
        className="modal-backdrop"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0,0,0,0.5)",
          zIndex: 1050,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        onClick={onClose}
      >
        <div
          className="modal-content p-3"
          style={{
            backgroundColor: "#fff",
            borderRadius: "8px",
            maxWidth: "500px",
            width: "90%",
            position: "relative",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <h5 className="mb-3">View Image</h5>
          <img
            src={imageUrl}
            alt="Preview"
            style={{
              maxWidth: "100%",
              borderRadius: "5px",
              marginBottom: "10px",
            }}
          />
          {/* <input type="file" accept="image/*" onChange={this.handleReplace} disabled /> */}
          <button className="btn btn-sm btn-secondary mt-2" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    );
  }
}

export default ImageReplaceModal;
